<template>
    <div class="pop" v-show="show" @click.stop='_=>{}'>
        <div class="box">
            <div id="close" class="close_btn" @click="close();closeCall()"></div>
            <div class="title"><img v-if='titleIcon != ""' :src="titleIcon">{{title}}</div>
            <div class="wrap">
                <div style="padding: 0 20px 14px 44px;">
                    订单提交成功！
                    <div style="margin-bottom: 10px;"></div>
                    <span class="i_tips" style="margin-left: -26px;"></span>款项需在开通授权日前到账，否则订单自动取消；汇款后请拨4008113366通知我司确认款项，开通授权，谢谢合作！
                </div>
                <div class="line"></div>
                <div style="padding: 10px 20px;">
                    <div class="book">
                        WT8付款到账后可获赠
                        <span style='color: #8b1212;'>《概率的朋友》</span>
                        一书，作者 乔烨等。
                        <div style="margin-bottom: 5px;"></div>
                        该书整合了作者30年实战经验与AI量化研究心得，书中交易策略均可回测、编码落地，适合零基础读者循序渐进学习量化实操。
                        <div style="text-align: center;padding: 14px 0 10px;">
                            <button class="roger" @click="yes">需要</button>
                            <button class="roger" @click="no">不需要</button>
                        </div>
                    </div>
                </div>
                
            </div>

        </div>
    </div>
</template>

<script>
    // @ is an alias to /src

    export default {
        name: 'alert',
        data: () => ({
            show: true
        }),
        props: {
            title: {
                default: '提示',
                type: String
            },
            confirmCall: {
                default: () => {},
                type: Function
            },
            titleIcon: {
                default: '',
                type: String
            },
            mountHandle: {
                default: ()=>{},
                type: Function
            },
            
            closeCall: {
                default: () => {},
                type: Function
            },
            mounted: {
                default: () => {},
                type: Function
            }
        },
        methods: {
            yes() {
                this.confirmCall(true)
                this.close()
            },
            no() {
                this.confirmCall(false)
                this.close()
            },
            close() {
                this.show = false
            }
        },
        watch: {
            mountHandle () {
                this.$nextTick(()=>{
                    this.mountHandle(this.close)
                })
            }
        },
        components: {

        }
    }
</script>

<style scoped>
    .book{
        background-color: #f1faff;   
        padding: 10px 8px 0;
        border-radius: 5px;
        font-size: 16px;
    }
    .line {
        background: url(../assets/image/line.png) repeat-x center;
        height:4px;
        margin-top: 10px;
        margin-bottom: 10px;
    }
    .pop {
        position: fixed;
        z-index: 2000;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, .2);
    }

    .box {
        width: 562px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }

    .title {
        height: 34px;
        background: url(../assets/image/confirm_title_bg.jpg) repeat-x;
        color: #fafafa;
        font-size: 15px;
        line-height: 34px;
        padding-left: 11px;
    }
    .title img {
        vertical-align: middle;
        margin-right: 5px;
        height: 16px;
        position: relative;
        top: -1px;
    }
    
    .close_btn {
            width: 35px;
            height: 35px;
            position: absolute;
            right: 0;
            top: 0;
            background: url(../assets/image/close.png) no-repeat center;
            background-size: 12px;
            cursor: pointer;
    }
    .wrap {
        background: #fff;
        border: 1px solid #8b8b8b;
        border-top: 0;
        padding: 28px 0;
        padding-bottom: 15px;
        color: #7c7c7c;
        font-size: 15px;
    }
    .wrap>>>a {
        color: rgb(73, 132, 212);
        text-decoration: underline;
    }
    .roger {
        color: #00497b;
        background: #b9e1fb;
        padding: 1px 0 3px;
        border-radius: 5px;
        width: 65px;
        cursor: pointer;
        display: inline-block;
        zoom: 1;
        margin: 0 15px;
        border: 0;
        outline: 0;
        font-size: 16px;
    }
    /* @media screen and (max-width: 494px) {
        .box {
            width: 95%;
        }
    } */
</style>